import { HumanDepartment } from './../../../middleware/autorization'
export default [
  {
    path: 'listar',
    name: 'list_employees',
    component: () => import('@/components/layouts/dashboard/ListEmployees'),
    meta: {
      pageSection: 'Funcionários',
      pageTitle: 'Lista de funcionários',
    },
    beforeEnter: HumanDepartment,
  },
]
